import { render, staticRenderFns } from "./Recomended.vue?vue&type=template&id=30016aa2&scoped=true"
import script from "./Recomended.vue?vue&type=script&lang=js"
export * from "./Recomended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30016aa2",
  null
  
)

export default component.exports